import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("areeba_admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (token && config.url && config.url.startsWith("/auth/me")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const formatINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const track = (event, meta = {}) => {
  api.post("/analytics/track", { event, meta }).catch(() => {});
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
